"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showLoginModal = showLoginModal;

function showLoginModal() {
  globalThis.dispatchEvent(new CustomEvent('GuestUserAction'));
}